import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $getRoot,
  $insertNodes,
} from "lexical";
import { useEffect } from "react";

export default function HTMLToJSONPlugin(props) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.update(() => {
      // // Clear the root before inserting new content to prevent duplicate content
      const root = $getRoot();
      root.clear();

      const parser = new DOMParser();
      const dom = parser.parseFromString(props.htmlString, "text/html");

      // Once you have the DOM instance it's easy to generate LexicalNodes.
      const nodes = $generateNodesFromDOM(editor, dom);

      // Select the root
      $getRoot().select();

      // Insert them at a selection.
      $insertNodes(nodes);
    });
  }, []);

  return null;
}